import React from 'react';
import { Link } from 'react-router';
import { LetterProcessing } from 'api';
import { connect } from 'react-redux';
import { header } from 'constants/table';
import { Toastr } from 'modules/toastr';
import DataTable from 'components/data-table';
import moment from 'moment';
import { msg } from 'constants/message';
import { CheckPermission } from 'modules/login/CheckPermission';
import { CheckQuyenBatDauQuyTrinh } from 'modules/login/CheckQuyenBatDauQuyTrinh';
import { FormSearch } from 'modules/handle-letters/list-handle-letters-search';
import { RowItemListHandleLetters } from 'modules/handle-letters/datatable/list';
import { RadioButtonChonTrangThaiXuLyDon } from 'components/tt-forms';
import {FormSort} from 'modules/reception/form-sort';
import { ShowIf } from 'components/utils';

class HandleLetters extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: this.props.data,
      trangThaiXuLyDon: 'DANG_XU_LY',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      sortBy: 'ngayTiepNhan,desc',
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,

      searchData: {},
      search: false,
      tableLoading: false,
      searchLoading: false,
      resetFormSearch: false
    };
  }

  componentDidMount() {
    window.scroll(0,0)
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    this.state.trangThaiXuLyDon = data.trangThaiDon || 'DANG_XU_LY';
    this.state.advanceSearch = data.advanceSearch || false;
    this.state.pageData.number = data.page || 0;
    this.state.pageData.size = data.size || 10;
    this.state.searchData.tuKhoa = data.tuKhoa || '';
    if (this.state.advanceSearch) {
      this.state.searchData.isSaveTemp = data.isSaveTemp;
      this.state.searchData.nguonDon = data.nguonDon || '';
      this.state.searchData.maDon = data.maDon || '';
      this.state.searchData.phanLoaiDon = data.phanLoaiDon || '';
      this.state.searchData.tinhTrangXuLy = data.trangThaiDonToanHT || '';
      this.state.searchData.ketQuaXuLy = data.ketQuaToanHT || '';
      this.state.searchData.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
      this.state.searchData.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
    }
    this.setState({...this.state});
    this.getListData();
    this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  openSearchForm() {
    this.setState({advanceSearch: true});
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    data.advanceSearch = true;
    localStorage.setItem('xldData', JSON.stringify(data));
  }

  closeSearchForm() {
    this.setState({advanceSearch: false});
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    data.advanceSearch = false;
    localStorage.setItem('xldData', JSON.stringify(data));
  }

  handleDelete(donId) {
    LetterProcessing.actions.deleteDon.request({
      id: donId
    }).then(res => {
      Toastr(msg.deleteLetterSucess, 'success');
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listXLD',
        idKey: 'donId',
        id: donId
      });
      this.getListData();
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.map(item => {
        Toastr(item.description, 'error');
      })
    });
  }

  // Note: ThuHoiDon
  handleThuHoi(donId) {
    LetterProcessing.actions.deleteDon.request({
      id: donId
    }).then(res => {
      Toastr(msg.thuHoiDon, 'success');
      this.getListData();
    });
  }

  handleChange(name, e) {
    this.setState({
      [e.target.name]: e.target.value
    })
    if (name === 'sortBy') {
      this.handleSort(e.target.value);
    }
  }

  async handleSort(sortBy) {
    let state = this.state;
    let params = {
      thanhLapDon: true,
      trangThaiDon: state.trangThaiXuLyDon,
      page: state.pageData.number,
      size: state.pageData.size,
      sort: sortBy
    };
    await this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true,
      resetFormSearch: false
    });
    if (state.searchData.isSaveTemp) {
      params.isSaveTemp = state.searchData.isSaveTemp;
    }
    if (state.searchData.tuKhoa) {
      params.tuKhoa = state.searchData.tuKhoa;
    }

    if (state.advanceSearch) {
      if (state.searchData.nguonDon) {
        params.nguonDon = state.searchData.nguonDon;
      }

      if (state.searchData.maDon) {
        params.maDon = state.searchData.maDon;
      }

      if (state.searchData.phanLoaiDon) {
        params.phanLoaiDon = state.searchData.phanLoaiDon;
      }

      if (state.searchData.tinhTrangXuLy) {
        params.trangThaiDonToanHT = state.searchData.tinhTrangXuLy;
      }

      if (state.searchData.ketQuaXuLy) {
        params.ketQuaToanHT = state.searchData.ketQuaXuLy;
      }

      if (state.searchData.startDate) {
        params.tiepNhanTuNgay = moment(state.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (state.searchData.endDate) {
        params.tiepNhanDenNgay = moment(state.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    await localStorage.setItem('xldData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    await LetterProcessing.actions.getListXuLyDon.request(params).then(async res => {
      if (this.refs.listXLD) {
        let Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.dons;
          this.setState({pageData: res.data.page});
        } else {
          state = {
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
          };
        }
        state = {
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        }
        await this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listXLD', data: Data});
      }
    }).catch(err => {
      state = {
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      };
    });
    await this.setState(state);
  }

  handleChangeTrangThaiXuLyDon(e) {
    this.setState({
      trangThaiXuLyDon: e.target.value,
      advanceSearch: false,
      searchData: {},
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      resetFormSearch: true
    }, () => {
      this.getListData();
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  handleSearch(searchData, e) {
    this.state.search = true;
    this.state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    this.setState({...this.state});

    if (!this.state.advanceSearch) {

      searchData = {
        tuKhoa: searchData.tuKhoa,
        trangThaiXuLyDon: searchData.trangThaiXuLyDon
      }
    }

    // Dung ung dung neu ngay nhap khong hop le
    if ([searchData.startDate, searchData.endDate].indexOf('INVALID') != -1) {
      return;
    }

    this.setState({searchData: searchData},() => {
      this.getListData()
    });
  }

  async getListData() {
    let state = this.state;
    let params = {
      thanhLapDon: true,
      trangThaiDon: state.trangThaiXuLyDon,
      page: state.pageData.number,
      size: state.pageData.size,
      sort: this.state.sortBy
    }
    state = {
      ...state,
      searching: true,
      tableLoading: true,
      searchLoading: true,
      resetFormSearch: false
    };
    await this.setState(state);
    if (state.searchData.isSaveTemp) {
      params.isSaveTemp = state.searchData.isSaveTemp;
    }

    if (state.searchData.tuKhoa) {
      params.tuKhoa = state.searchData.tuKhoa;
    }

    if (state.advanceSearch) {
      if (state.searchData.nguonDon) {
        params.nguonDon = state.searchData.nguonDon;
      }

      if (state.searchData.maDon) {
        params.maDon = state.searchData.maDon;
      }

      if (state.searchData.phanLoaiDon) {
        params.phanLoaiDon = state.searchData.phanLoaiDon;
      }

      if (state.searchData.tinhTrangXuLy) {
        params.trangThaiDonToanHT = state.searchData.tinhTrangXuLy;
      }

      if (state.searchData.ketQuaXuLy) {
        params.ketQuaToanHT = state.searchData.ketQuaXuLy;
      }

      if (state.searchData.startDate) {
        params.tiepNhanTuNgay = moment(state.searchData.startDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }

      if (state.searchData.endDate) {
        params.tiepNhanDenNgay = moment(state.searchData.endDate, 'DD/MM/YYYY').add(7, 'hours').toISOString();
      }
    }
    await localStorage.setItem('xldData', JSON.stringify({...params, advanceSearch: this.state.advanceSearch}));
    await LetterProcessing.actions.getListXuLyDon.request(params).then(async res => {
      if (this.refs.listXLD) {
        let Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.dons;
          this.setState({pageData: res.data.page});
        } else {
          state = {
            ...state,
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
          };
        }
        state = {
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        }
        await this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listXLD', data: Data});
      }
    }).catch(err => {
      state = {
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      };
    });
    await this.setState(state);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  render() {
    return (
      <div ref="listXLD">
        <div className="center reception-container">
          <div className="top-content">
            <RadioButtonChonTrangThaiXuLyDon disable={this.state.tableLoading} selectedValue={this.state.trangThaiXuLyDon} onChange={this.handleChangeTrangThaiXuLyDon.bind(this)} />
            <ShowIf condition={CheckPermission('XULYDON_THEM') && CheckQuyenBatDauQuyTrinh()}>
              <div className="right-content">
                <Link className="btn-green" to="/xu-ly-don/them-moi"><i className="tt tt-addfile"></i>Thêm mới</Link>
              </div>
            </ShowIf>
          </div>
          <div className="bottom-content">
            <div className={this.state.advanceSearch ? 'search-container super-search' : 'search-container'}>
              <FormSearch onStatus={this.state.trangThaiXuLyDon} advanceSearch={this.state.advanceSearch} onCancel={this.closeSearchForm.bind(this)} handleSearch={this.handleSearch.bind(this)} disabled={ this.state.searching } search={ this.state.search } resetForm={this.state.resetFormSearch} />
              <Link className="rearch-text" onClick={this.openSearchForm.bind(this)}><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <FormSort
              type='soXuLyDon'
              pageDetail={this.state.pageData}
              selectedValue={this.state.sortBy}
              onChange={ this.handleChange.bind(this, 'sortBy') }
            />
            <DataTable header={header.listXLD}
              dataList={this.state.data}
              searchData={this.state.searchData}
              exporttext="Xuất sổ xử lý đơn"
              sortBy={this.state.sortBy}
              typeExport="XU_LY_DON"
              pageData={this.state.pageData}
              parent={this}
              search={this.state.search}
              redux={this}
              tableLoading={this.state.tableLoading}>
              <RowItemListHandleLetters
                type={this.state.trangThaiXuLyDon}
                getListData={this.getListData.bind(this)} />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}

HandleLetters.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD
  };
}

export default connect(bindStateToProps)(HandleLetters);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/list-handle-letters/HandleLetters.jsx